import React, { useState, useEffect, memo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Nav, Modal } from 'react-bootstrap';
import close from '../Asset/close.svg';
import wakie from '../Asset/non-active-icon/wakie.svg';
import technician from '../Asset/non-active-icon/technician.svg';
import god_user from '../Asset/non-active-icon/god_user.svg';
import uti from '../Asset/non-active-icon/uti.svg';
import fuel from '../Asset/non-active-icon/fuel.svg';
import imp from '../Asset/non-active-icon/imp.svg';
import geo from '../Asset/non-active-icon/geo.svg';
import sr from '../Asset/non-active-icon/sr.svg';
import main from '../Asset/non-active-icon/main.svg';
import impact from '../Asset/non-active-icon/impact.svg';
import inci from '../Asset/non-active-icon/inci.svg';
import eq360 from '../Asset/non-active-icon/eq360.svg';
import ope from '../Asset/non-active-icon/ope.svg';
import shift from '../Asset/non-active-icon/shift.svg';
import srlist from '../Asset/non-active-icon/srlist.svg';
import profile from '../Asset/non-active-icon/profile.svg';
import logouti from '../Asset/non-active-icon/logout.svg';
import { getUserInfo, setDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { environment } from './functions/environment';
import { signOut } from '../Azure-ad/authService'

function Sidebar(props) {
  const adType = sessionStorage.getItem("adType");
  const navigate = useNavigate();
  let [sessOut, setSessOut] = useState(false);
  const [dashboard, setStateDashboard] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = sessionStorage.getItem('userInfo') ? getUserInfo() : {};

  useEffect(() => {
    if (user.userType == "account_user") {
      getDashboardByUser(user.token);
    }
  }, [])

  function getDashboardByUser(token) {
    fetch(environment.baseUrl + "getDashboardByUser?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          let temp = [];
          if (res.data.result.length) {
            res.data.result.map((item) =>
              temp.push(item.dashboardID)
            )
            setStateDashboard(temp);
            setDashboard(temp);
          }
          else {
            navigate('/profile');
          }
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setStateDashboard([]);
        }
      })
    })
  }
  // get browser name which pass to logout api
  function getBrowserName() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return ('Opera');
    }
    else if (navigator.userAgent.indexOf("Edg") != -1) {
      return ('Edge');
    }
    else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return ('Chrome');
    }
    else if (navigator.userAgent.indexOf("Safari") != -1) {
      return ('Safari');
    }
    else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return ('Firefox');
    }
    else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
      return ('IE');
    }
    else {
      return ('unknown');
    }
  }
  // get stored device id from the cookies, which pass to logout api
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  //logout api call
  function logout() {
    sessionStorage.clear();
    props.aapFun(false)
    navigate('/login');
    let did = getCookie("deviceID");
    //console.log(did);

    if (did != "") {
      fetch(environment.baseUrl + "logout", {
        method: "PUT",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
        body: JSON.stringify({
          deviceType: "web",
          deviceID: did,
          deviceDetails: {
            webBrowser: getBrowserName()
          }
        })
      }).then((result) => {
        result.json().then((res) => {
          if (res.code === 200) {
            signOut(adType);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            console.log(res.msg);
          }
        })
      })
    }
  }

  // for show active screen in sidebar
  function setClass(rlink, tid) {
    if (!dashboard.includes(tid)) {
      return ("d-none");
    }
    else if (location.pathname === rlink) {
      return ("nav-link activelink")
    }
    else {
      return ("nav-link")
    }
  }
  const location = useLocation();
  //console.log(location.pathname);

  // let showS = true;
  return (
    <div className='sidebar'  >
      <SessionFun show={sessOut}></SessionFun>
      {/* ========= SIDEBAR ADMIN/USER SCREEN ================= */}
      {
        user.userType === 'account_user' ?
          <Nav defaultActiveKey='/my-equipment' className="flex-column">
            <Link className={setClass("/my-equipment", 11)} to="/my-equipment"><img className={location.pathname === '/my-equipment' ? 'active_icon' : ''} src={eq360} />&nbsp; My Equipment</Link>
            <Link className={setClass("/utilization", 1)} to="/utilization"><img className={location.pathname === '/utilization' ? 'active_icon' : ''} src={uti} />&nbsp; Utilization Dashboard</Link>
            <Link className={setClass("/fuel-consumption", 6)} to="/fuel-consumption"><img className={location.pathname === '/fuel-consumption' ? 'active_icon' : ''} src={fuel} />&nbsp; Fuel Analysis</Link>
            <Link className={setClass("/imp-parameter", 3)} to="/imp-parameter"><img className={location.pathname === '/imp-parameter' ? 'active_icon' : ''} src={imp} />&nbsp; Important Parameters</Link>
            <Link className={setClass("/geo", 4)} to="/geo"><img className={location.pathname === '/geo' ? 'active_icon' : ''} src={geo} />&nbsp; Geofencing</Link>
            <Link className={setClass("/createGeo", 14)} to="/createGeo"><img className={location.pathname === '/createGeo' ? 'active_icon' : ''} src={geo} />&nbsp; Create Geofence</Link>
            <Link className={setClass("/location_tracking", 15)} to="/location_tracking"><img className={location.pathname === '/location_tracking' ? 'active_icon' : ''} src={geo} />&nbsp; Location Tracking</Link>
            <Link className={setClass("/service-request", 2)} to="/service-request"><img className={location.pathname === '/service-request' ? 'active_icon' : ''} src={sr} />&nbsp; Service Request</Link>
            <Link className={setClass("/maintenance", 5)} to="/maintenance"><img className={location.pathname === '/maintenance' ? 'active_icon' : ''} src={main} />&nbsp; Maintenance</Link>
            <Link className={setClass("/impact", 9)} to="/impact"><img className={location.pathname === '/impact' ? 'active_icon' : ''} src={impact} />&nbsp; Impact</Link>
            <Link className={setClass("/incident", 8)} to="/incident"><img className={location.pathname === '/incident' ? 'active_icon' : ''} src={inci} />&nbsp; Incident</Link>
            <Link className={setClass("/home", 13)} to="/home"><img className={location.pathname === '/home' ? 'active_icon' : ''} src={eq360} />&nbsp; Equipment 360</Link>
            <Link className={setClass("/operator", 7)} to="/operator"><img className={location.pathname === '/operator' ? 'active_icon' : ''} src={ope} />&nbsp; Operator</Link>
            <Link className={setClass("/shift-master", 12)} to="/shift-master"><img className={location.pathname === '/shift-master' ? 'active_icon' : ''} src={shift} />&nbsp; Shifts </Link>
            <Link className={setClass("/service-request-list", 10)} to="/service-request-list"><img className={location.pathname === '/service-request-list' ? 'active_icon' : ''} src={srlist} />&nbsp; Service Request List</Link>
            <div className="fixsed-bottom mb-2">
              <Link className={location.pathname === '/profile' ? 'nav-link activelink' : 'nav-link'} to="/profile"><img className={location.pathname === '/profile' ? 'active_icon' : ''} src={profile} />&nbsp; Profile</Link>
              <a onClick={handleShow} style={{ cursor: 'pointer' }} className='nav-link'><img src={logouti} />&nbsp; Log Out</a>
            </div>
          </Nav>
          :

          user.userType === 'admin' ?
            <Nav defaultActiveKey='/accounts' className="flex-column">
              <Link className={location.pathname === '/accounts' ? 'nav-link activelink' : 'nav-link'} to="/accounts"><i className='fa fa-user-circle'></i>&nbsp;  Accounts</Link>
              <Link className={location.pathname === '/assets-lists' ? 'nav-link activelink' : 'nav-link'} to="/assets-lists"><i className='fa fa-money'></i>&nbsp; Assets Lists</Link>
              <Link className={location.pathname === '/asset-upload' ? 'nav-link activelink' : 'nav-link'} to="/asset-upload"><i className='fa fa-upload'></i>&nbsp; Assets Upload</Link>
              <Link className={location.pathname === '/asset-onboarding' ? 'nav-link activelink' : 'nav-link'} to="/asset-onboarding"><i className='fa fa-rocket'></i>&nbsp; Asset Onboarding</Link>
              <Link className={location.pathname === '/asset-user-mapping' ? 'nav-link activelink' : 'nav-link'} to="/asset-user-mapping"><i className='fa fa-user-plus'></i>&nbsp; Asset User Mapping</Link>
              <Link className={location.pathname === '/service-request-list' ? 'nav-link activelink' : 'nav-link'} to="/service-request-list"><i className='fa fa-list'></i>&nbsp; Service Request List</Link>
              <Link className={location.pathname === '/dashboard-group-creation' ? 'nav-link activelink' : 'nav-link'} to="/dashboard-group-creation"><i className='fa fa-users'></i>&nbsp; Create Dashboard Group</Link>
              <Link className={location.pathname === '/dashboard-group-mapping' ? 'nav-link activelink' : 'nav-link'} to="/dashboard-group-mapping"><i className='fa fa-sitemap'></i>&nbsp; Map Dashboard Group</Link>
              <Link className={location.pathname === '/fuel_tank_capacity' ? 'nav-link activelink' : 'nav-link'} to="/fuel_tank_capacity"><img className={location.pathname === "/fuel_tank_capacity" ? 'active_icon' : ""} src={wakie} />&nbsp; <span > Fuel Tank Capacity</span></Link>
              {
                user.isSuperUser ?
                  <Link className={location.pathname === '/adminUser' ? 'nav-link activelink' : 'nav-link'} to="/adminUser"><i className='fa fa-user-plus'></i>&nbsp; Add Admin User</Link>

                  : ""
              }
              <Link className={location.pathname === '/technician-master' ? 'nav-link activelink' : 'nav-link'} to="/technician-master"><img className={location.pathname === "/technician-master" ? 'active_icon' : ""} src={technician} />&nbsp;Technician Master</Link>
              <Link className={location.pathname === '/godrej-user-List' ? 'nav-link activelink' : 'nav-link'} to="/godrej-user-List"><img className={location.pathname === "/godrej-user-List" ? 'active_icon' : ""} src={god_user} />&nbsp; Godrej User List</Link>


              <div className="fixsed-bottom mb-2">
                <Link className={location.pathname === '/profile' ? 'nav-link activelink' : 'nav-link'} to="/profile"><i className='fa fa-user'></i>&nbsp; Profile</Link>
                <a onClick={handleShow} style={{ cursor: 'pointer' }} className='nav-link'><i className='fa fa-sign-out'></i>&nbsp; Log Out</a>
              </div>
            </Nav>

            :
            user.userType === 'technician_user' ?
              <Nav defaultActiveKey='/preventive_maintenance' className="flex-column">
                <Link className={location.pathname === '/preventive_maintenance' ? 'nav-link activelink' : 'nav-link'} to="/preventive_maintenance"><i className='fa fa-money'></i>&nbsp; Preventive Maintanence</Link>
                <div className="fixsed-bottom mb-2">
                  <Link className={location.pathname === '/profile' ? 'nav-link activelink' : 'nav-link'} to="/profile"><i className='fa fa-user'></i>&nbsp; Profile</Link>
                  <a onClick={handleShow} style={{ cursor: 'pointer' }} className='nav-link'><i className='fa fa-sign-out'></i>&nbsp; Log Out</a>
                </div>
              </Nav>
              : ""
      }

      <Modal show={show} onHide={handleClose} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>Confirm Log Out</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='text-center logout-box'>
          <p><b>Log Out From The System ?</b></p>
          <p>You can always access your system by signing back in</p>
          <div className="row mt-3">
            <div className="col-sm-6 ">
              <button className="btn btn-outline-secondary float-end" onClick={handleClose}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6 ">
              <button className="btn btn-light confirm-btn float-start" onClick={logout}>
                Log Out
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default memo(Sidebar);